import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Grid,
    TextField,
    Typography,
} from '@material-ui/core';
import Popup from './Popup'
import api from '../services/api';

export default function PopUpDetailsTable({ user, open, setOpen, title }) {
const [vehicleTypes,setVehicleTypes] = useState([]);

     useEffect(() => {
        const findTypes = async () => {
            try {
                const result = await api.get('/vehicle_type/list', {
                    params: {
                        show_exceptions: true,
                        limit: 30,
                    }
                });

                const { vehicleTypes } = result.data;

                setVehicleTypes(vehicleTypes);
            } catch (err) {
                console.log(err)
            }
        }

        findTypes();
    }, []);

    const vehicleTypeName = (id) => {
        let result = ''
        if (!id)
            return "Não informado"

        vehicleTypes.forEach(current => {
            if (current.id === id) {
                result = current.name;
            }
        });

        return result;
    };
    return (
        <Popup
            openPopup={open}
            setOpenPopup={setOpen}
            title={`Detalhes do ${title}`}
            width="min(680px, 100%)"
            maxWidth="sm">
            <Grid container justifyContent="center"
                alignItems="center" spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        colorSecondary
                        label="ID"
                        value={user?.id ?? ''}
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='outlined'
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        colorSecondary
                        label="Marca"
                        value={user?.car_brand ?? ''}
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='outlined'
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        colorSecondary
                        label="Modelo"
                        value={user?.model ?? ''}
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='outlined'
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        colorSecondary
                            label="Tipo"
                            value={vehicleTypeName(user?.vehicle_type_id)}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant='outlined'
                            fullWidth
                        />
                    </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        colorSecondary
                        label="Placa"
                        value={user?.license_plate ?? ''}
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='outlined'
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        colorSecondary
                        label="Cor"
                        value={user?.color ?? ''}
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='outlined'
                        fullWidth
                    />
                </Grid>
            </Grid>

            <Typography variant="subtitle1" style={{ fontWeight: 700, marginTop: 24, marginBottom: 8, color: '#334155' }}>
                Usuários vinculados ({user?.users?.length ?? 0})
            </Typography>
            <TableContainer style={{ maxHeight: 280, overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 8 }}>
            <Table size="small" stickyHeader aria-label="Usuários vinculados ao veículo">
                <TableHead>
                    <TableRow>
                        <TableCell >ID</TableCell>
                        <TableCell >Usuários</TableCell>
                        <TableCell >Número</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {user?.users?.map(item => (
                        <TableRow key={item?.id}>
                            <TableCell>
                                {item?.id}
                            </TableCell>
                            <TableCell>
                                {item?.name}
                            </TableCell>
                            <TableCell>
                                {item?.phone}
                            </TableCell>
                        </TableRow>))}
                    {!user?.users?.length && (
                        <TableRow><TableCell colSpan={3} align="center">Nenhum usuário vinculado</TableCell></TableRow>
                    )}
                </TableBody>

            </Table>
            </TableContainer>
        </Popup>
    );
}
